import { ACTION } from "@/lib/auth/actions";
import { hasPermission } from "@/lib/authv2/permissions";

// Khoá `makeup_tier_gate` rơi vào cổng mặc định settings.write của máy chủ
// (admin + giám đốc) — hỏi đúng quyền đó, không hỏi vai.
export function canManageMakeupTierGate(): boolean {
  return hasPermission(ACTION.SettingsWrite);
}
